import type { PageMeta } from "@repo/dashboard-core";

// CUSTOMIZE: Map routes to page title/subtitle translation keys
export const routeMap: Record<string, PageMeta> = {
  "/": {
    titleKey: "page-meta.my-top-ups.title",
    subtitleKey: "page-meta.my-top-ups.subtitle",
  },
  "/library": {
    titleKey: "page-meta.library.title",
    subtitleKey: "page-meta.library.subtitle",
  },
  "/international-calls": {
    titleKey: "page-meta.international-calls.title",
    subtitleKey: "page-meta.international-calls.subtitle",
  },
  "/esim": {
    titleKey: "page-meta.esim.title",
    subtitleKey: "page-meta.esim.subtitle",
  },
  // Before "/send-sms": `getPageMeta` takes the first route the path starts
  // with, so the shorter one would claim the compose page too.
  "/send-sms/new": {
    titleKey: "page-meta.send-sms.title",
    subtitleKey: "page-meta.send-sms.subtitle",
  },
  "/send-sms": {
    titleKey: "page-meta.sms-history.title",
    subtitleKey: "page-meta.sms-history.subtitle",
  },
  "/phone-checker": {
    titleKey: "page-meta.phone-checker.title",
    subtitleKey: "page-meta.phone-checker.subtitle",
  },
  "/earn-back": {
    titleKey: "page-meta.earn-back.title",
    subtitleKey: "page-meta.earn-back.subtitle",
  },
  "/profile": {
    titleKey: "page-meta.profile.title",
    subtitleKey: "page-meta.profile.subtitle",
  },
  "/messages": {
    titleKey: "page-meta.messages.title",
    subtitleKey: "page-meta.messages.subtitle",
  },
  "/faq": {
    titleKey: "page-meta.faq.title",
    subtitleKey: "page-meta.faq.subtitle",
  },
  "/contact": {
    titleKey: "page-meta.contact.title",
    subtitleKey: "page-meta.contact.subtitle",
  },
};

/** GD-98 — the eSIM customer's home is "My dashboard"; every other page keeps
 * its title. */
export const esimRouteMap: Record<string, PageMeta> = {
  ...routeMap,
  "/": {
    titleKey: "page-meta.my-dashboard.title",
    subtitleKey: "page-meta.my-dashboard.subtitle",
  },
};
